import { OptJobUnitSetting } from 'api/optJobs/optJobs.api'
import React, { createContext, PropsWithChildren, ReactElement, useCallback, useContext, useState } from 'react'

type OptModelOptimizationContextValue = {
  unitSettings: Record<string, OptJobUnitSetting>
  setUnitSettings: (unitSettings: Record<string, OptJobUnitSetting>) => void
  isValid: boolean
  setIsValid: (isValid: boolean) => void
}

const OptModelOptimizationContext = createContext<OptModelOptimizationContextValue | undefined>(undefined)

export function OptModelOptimizationProvider({ children }: PropsWithChildren): ReactElement {
  const [unitSettings, setUnitSettings] = useState<Record<string, OptJobUnitSetting>>({})
  const [isValid, setIsValid] = useState(true)

  const handleSetUnitSettings = useCallback((newUnitSettings: Record<string, OptJobUnitSetting>) => {
    setUnitSettings(newUnitSettings)
  }, [])

  const handleSetIsValid = useCallback((newIsValid: boolean) => {
    setIsValid(newIsValid)
  }, [])

  return (
    <OptModelOptimizationContext.Provider
      value={{
        unitSettings,
        setUnitSettings: handleSetUnitSettings,
        isValid,
        setIsValid: handleSetIsValid,
      }}
    >
      {children}
    </OptModelOptimizationContext.Provider>
  )
}

export function useOptModelOptimizationContext(): OptModelOptimizationContextValue {
  const context = useContext(OptModelOptimizationContext)
  if (!context) {
    throw new Error('useOptModelOptimizationContext must be used within an OptModelOptimizationProvider')
  }
  return context
}
